module.exports = __webpack_public_path__ + "static/media/recharge-successful.9f410981.svg";